var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 0.5H21.375C21.9844 0.5 22.5 1.01562 22.5 1.625C22.5 2.28125 21.9844 2.75 21.375 2.75H4.125C3.04688 2.75 2.25 3.59375 2.25 4.625V17.375C2.25 18.4531 3.04688 19.25 4.125 19.25H19.875C20.9062 19.25 21.75 18.4531 21.75 17.375V9.125C21.75 8.09375 20.9062 7.25 19.875 7.25H5.625C4.96875 7.25 4.5 6.78125 4.5 6.125C4.5 5.51562 4.96875 5 5.625 5H19.875C22.125 5 24 6.875 24 9.125V17.375C24 19.6719 22.125 21.5 19.875 21.5H4.125C1.82812 21.5 0 19.6719 0 17.375V4.625C0 2.375 1.82812 0.5 4.125 0.5ZM18 14.75C17.1562 14.75 16.5 14.0938 16.5 13.25C16.5 12.4531 17.1562 11.75 18 11.75C18.7969 11.75 19.5 12.4531 19.5 13.25C19.5 14.0938 18.7969 14.75 18 14.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.9ad860c1532e72109138f6b0feb5fad5.svg";
export { ForwardRef as ReactComponent };